import MeterReadDetailsTable from './MeterReadDetailsTable';

export interface FeeAdjustmentsData {
  forecastFee: number | null;
  adminFee: number | null;
  counterParty: number | null;
}

type Cell = {
  month_year: string;
  value: number | string | null;
  id?: null;
  idName?: string;
  readonly?: boolean;
  isApproved?: boolean;
};

type Row = { field: string; label: string; months: Cell[]; editable?: boolean };

const FEE_FIELDS: { field: keyof FeeAdjustmentsData; label: string }[] = [
  { field: 'forecastFee', label: 'Forecast Fee' },
  { field: 'adminFee', label: 'Admin Fee' },
  { field: 'counterParty', label: 'Counter Party' },
];

interface MeterReadDetailsFeeTableProps {
  id: string | undefined;
  feeDataByMonth: Record<string, FeeAdjustmentsData>;
  months: { monthYear: string; approvalStatus: string | null; invoiceApproved?: boolean | null }[];
  start?: Date;
  end?: Date;
  shouldUseContractView?: boolean;
}

const MeterReadDetailsFeeTable = ({
  id, feeDataByMonth, months, start, end, shouldUseContractView,
}: MeterReadDetailsFeeTableProps) => {
  const rows: Row[] = FEE_FIELDS.map(({ field, label }) => ({
    label,
    field,
    months: months.map((m) => ({
      month_year: m.monthYear,
      value: feeDataByMonth[m.monthYear]?.[field] ?? null,
      id: null,
      idName: 'meter_computed_id',
      readonly: true,
      isApproved: m.approvalStatus === 'Approved' || !!m.invoiceApproved,
    })),
    editable: false,
  }));

  return (
    <MeterReadDetailsTable
      id={id}
      rows={rows}
      handleChange={() => {}}
      saving={false}
      updating={false}
      start={start}
      end={end}
      shouldUseContractView={shouldUseContractView}
      isEditable={false}
      testTable="invoice-adjustments"
    />
  );
};

export default MeterReadDetailsFeeTable;
